export default __webpack_public_path__ + "img/egina.bb3120d4.jpg";